import { getItemByField } from "../../../../../../web-graphics";
import { WebglSettingsConverter } from "../webgl-settings-converter";

export class PlotWebglSettingsConverter extends WebglSettingsConverter {
  constructor(dataSourceConverter, signalsCreator) {
    super();
    this.dataSourceConverter = dataSourceConverter;
    this.signalsCreator = signalsCreator;
  }

  convert(settings) {
    let settingsCopy = settings.copy();
    this._addLinkedChannel(settingsCopy);
    if (settings.dataSources !== undefined && this.dataSourceConverter !== undefined) {
      settingsCopy.dataSources = [];
      let leadRaySettings = getItemByField("name", "leadRay", settingsCopy.plotContent?.aboveCentral);
      const isNeedChannelLeadRay = !(leadRaySettings.settings.synchronized ?? true);
      settingsCopy._isNeedChannelLeadRay = isNeedChannelLeadRay;
      for (let dataSourceIndex = 0; dataSourceIndex < settings.dataSources.length; dataSourceIndex++) {
        let dataSourceSettings = settings.dataSources[dataSourceIndex];
        dataSourceSettings._plotSettings = settingsCopy;
        dataSourceSettings._isNeedChannelLeadRay = isNeedChannelLeadRay;
        dataSourceSettings._isSynchronizedScaleX = isNeedChannelLeadRay ? false : settingsCopy.synchronizedScaleX;
        settingsCopy.dataSources.push(this.dataSourceConverter.convert(dataSourceSettings));
      }
    }
    settingsCopy._signalsCreator = this.signalsCreator;
    return settingsCopy;
  }

  _addLinkedChannel(plotSettings) {
    const plotControlsSettings = getItemByField("name", "plotControls", plotSettings.plotContent?.custom)?.settings;
    if (plotControlsSettings === undefined || plotControlsSettings.linkedChannel !== undefined) {
      return;
    }
    const channelSettings = this._getFirstChannel(plotSettings.dataSources);
    if (channelSettings === undefined) {
      return;
    }
    plotControlsSettings.linkedChannel = {
      id_dataSource: channelSettings.id_dataSource,
      id: channelSettings.id_channel
    };
  }

  _getFirstChannel(dataSources) {
    for (let dataSourceIndex = 0; dataSourceIndex < dataSources.length; dataSourceIndex++) {
      const dataSourceSettings = dataSources[dataSourceIndex];
      if (dataSourceSettings.channels.length > 0) {
        return dataSourceSettings.channels[0];
      }
    }
    return undefined;
  }
}
